import React, { useEffect } from 'react';
import HomeLayout from 'layouts/HomeLayout';
import HeroSection from 'components/Lifetime/HeroSection/HeroSection';
import FeaturesSection from 'components/Lifetime/FeaturesSection/FeaturesSection';
import FAQSection from 'components/Lifetime/FAQSection/FAQSection';
import CTASection from 'components/Lifetime/CTASection/CTASection';
import SavingsCalculator from 'components/Lifetime/SavingsCalculator/SavingsCalculator';
import PanicBanner from 'components/Lifetime/PanicBanner/PanicBanner';
import "./style.scss"
import LifetimePlanCard from 'components/LifetimePlan/LifetimePlan';
import Review from '../Reviews/Reviews';
import { trackLifetimePageView } from 'utils/tracking';

const LifetimePlan: React.FC = () => {
  useEffect(() => {
    trackLifetimePageView();
  }, []);

  return (
    <HomeLayout title="Lifetime Plan - Sellerdash">
      <main className="lifetime-plan-page">
        <HeroSection />
        <PanicBanner />
        <LifetimePlanCard page={"cta"} />
        <FeaturesSection />
        <SavingsCalculator />
        <Review isPage={true} />
        <FAQSection />
        <CTASection />
      </main>
    </HomeLayout>
  );
};

export default LifetimePlan;